// extracted by mini-css-extract-plugin
export var container = "Menu-module--container--2f0b8";
export var visuallyHidden = "Menu-module--visuallyHidden--c28be";